import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMotorTimeSlotStart,
  getMotorTimeSlotSuccess,
  getMotorTimeSlotFailure,
} from "../reducers/getMotorTimeSlotReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getMotorTimeSlot = createAsyncThunk(
  "getMotorTimeSlot",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getMotorTimeSlotStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Motor/GetPrefferedTimeSlot`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getMotorTimeSlotSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getMotorTimeSlotFailure(error.response.data.Message));

      throw error;
    }
  }
);
